import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";
import ErrModalPop from 'components/sales/modal/errorModal';
import ModalPop from "components/sales/modal/modal";
import { toast } from "react-toastify";

const ValetUserList = ({
  valetIncentiveList,
  valetincentivelisting,
  bulkApprovalData={},
  valetUserBulkApprove
}) => {
  const headers = [
    // "Select",
    "User Name",
    "User ID",
    "Project ID",
    "Project Name",
    "Phone Number",
    "Role",
    "Project Type",
    "Total Amount Earned",
    "Total Amount Approved",
    "",
    "Action",
  ];
  const tableData = [
    // "multi_select",
    "user_name",
    "user_id",
    "project_id",
    "project_name",
    "phone_number",
    "role",
    "project_type",
    "total_amount_earned",
    "total_amount_approved",
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const [headerState,setHeaderState]=useState(headers);
  const [tableDataState,setTableDataState]=useState(tableData);
  const [multiSelectStatus,setMultiSelectStatus]=useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  
  const headerBtns = () => {
    return (
      <Fragment>
        {multiSelectStatus ? (
          <Button
            onClick={mutiSelectApprove}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.SelectMenu} alt="" />
            {localization.approve}
          </Button>
        ) : (
          <Button
            onClick={mutiSelectOpen}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.SelectMenu} alt="" />
            {localization.multiSelect}
          </Button>
        )}
        
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const mutiSelectApprove = async() => {
    if(selectedItems.length==0){
      toast.error("Please select atleast one item");
      return;
    }
    let filterDataO = localStorage.getItem("filterDataIncentive");
    let filterDataObj = JSON.parse(filterDataO);
    let toDate = filterDataObj.to_date;
    let fromDate = filterDataObj.from_date;
    setIsLoading(true);
    const res=await valetUserBulkApprove(fromDate,toDate,selectedItems);
    if(res==true){
      setSaveModal(true);
    }else{
      setIsErrorModal(true);
    }
    setIsLoading(false)
  }
  const mutiSelectOpen = () => {
    const newHeaders=[
      "Select",
      "User Name",
      "User ID",
      "Project ID",
      "Project Name",
      "Phone Number",
      "Role",
      "Project Type",
      "Total Amount Earned",
      "Total Amount Approved",
      "",
      "Action",
    ];
    const newTableData=[
      "multi_select",
      "user_name",
      "user_id",
      "project_id",
      "project_name",
      "phone_number",
      "role",
      "project_type",
      "total_amount_earned",
      "total_amount_approved",
    ];

    setHeaderState(newHeaders);
    setTableDataState(newTableData);
    setMultiSelectStatus(true);
  }
  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const today = new Date();
  const firstDate = new Date(today.getFullYear(), today.getMonth(), 1);
  const date = new Date(firstDate);
  const year = date.getFullYear();
  const month = ("0" + (date.getMonth() + 1)).slice(-2);
  const day = ("0" + date.getDate()).slice(-2);
  const formatFirstDate = `${year}-${month}-${day}`;

  const todayDate = today.toISOString().split("T")[0];

  const applyFilter = async (filterData) => {
    // console.log("Filter Data:", filterData);
    // return false;
    setIsLoading(true);
    setFilterData(filterData);
    localStorage.setItem("incentiveCount",1);
    setListData([]);
    console.log("FILTER",filterData)
    await valetIncentiveList(filterData, 1);
    setIsLoading(false);
    console.log(filterData.from_date);
    if(filterData.from_date === undefined || filterData.from_date === '') {
      localStorage.setItem("filterDataIncentive", `{"to_date":"${todayDate}","from_date":"${formatFirstDate}"}`);
    }else{
      localStorage.setItem("filterDataIncentive",JSON.stringify(filterData));
    }
    
    filterToggle();
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      let pageValet = 1;
      if(localStorage.getItem("valetIncentivePage")){
        pageValet = localStorage.getItem("valetIncentivePage");
      }
      if(localStorage.getItem("filterDataIncentive") && localStorage.getItem("incentiveCount") && localStorage.getItem("incentiveCount") > 0){
        let filterDataO = localStorage.getItem("filterDataIncentive");
        let filterDataObj = JSON.parse(filterDataO);
        let toDate = filterDataObj.to_date;
        let fromDate = filterDataObj.from_date;

        await valetIncentiveList({"to_date":toDate,"from_date":fromDate}, pageValet);
        setIsLoading(false);

        if((fromDate === null || fromDate === undefined || fromDate === "") && (toDate === null || toDate === undefined || toDate === "")){
          const today = new Date();
          const todayDate = today.toISOString().split("T")[0];
    
          const firstDate = new Date(today.getFullYear(), today.getMonth(), 1);
          const date = new Date(firstDate);
          const year = date.getFullYear();
          const month = ("0" + (date.getMonth() + 1)).slice(-2);
          const day = ("0" + date.getDate()).slice(-2);
          const formatFirstDate = `${year}-${month}-${day}`;
          localStorage.setItem("filterDataIncentive", `{"to_date":"${todayDate}","from_date":"${formatFirstDate}"}`);
          await valetIncentiveList(null, pageValet);
          setIsLoading(false);
        }

      }else{
        const today = new Date();
        const todayDate = today.toISOString().split('T')[0];
  
        const firstDate = new Date(today.getFullYear(), today.getMonth(), 1);
        const date = new Date(firstDate);
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const formatFirstDate = `${year}-${month}-${day}`;
        localStorage.setItem("filterDataIncentive", `{"to_date":"${todayDate}","from_date":"${formatFirstDate}"}`);
        await valetIncentiveList(null, pageValet);
      setIsLoading(false);
      }
      

    };
    fetchData();
  }, [valetIncentiveList]);
  
  
  const onPageChange = async (val) => {
    setIsLoading(true);
    localStorage.setItem("valetIncentivePage", val.selected+1);
    await valetIncentiveList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  useEffect(() => {

    
    if (valetincentivelisting && valetincentivelisting.resultSets) {
      const data = valetincentivelisting.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableDataState.map((key) => ({ [key]: element[key] })),
          {
            created_ats: element.created_at,
            Action: [
              {
                name: "Approve/Reject Incentive",
                link: `/dashboard/valet-incentive-portal/${element.user_id}/${valetincentivelisting.start_date}/${valetincentivelisting.end_date}/${element.project_id}`
              },
              {
                name: "Last 5 Transactions",
                link: `/dashboard/last-five-transactions/${element.user_id}`,
              },
            ],
          }
        )
      );

      if (data.length > 0) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(valetincentivelisting.total / valetincentivelisting.per_page)
      );
    }
  }, [valetincentivelisting,tableDataState]);


  return (
    <Layout
      title={localization.valetListing}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <ModalPop
        title={localization.success}
        show={saveModal}
        handleModalHide={()=>{
          setSaveModal(false)
          window.location.reload();
        }}
        keyboard
      >
        <div className="text-center">
          
          <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
          
          <h5>Approved !</h5>
          
        
        </div>
      </ModalPop>
          
      <ErrModalPop
            title={localization.error}
            show={isErrorModal}
            handleModalHide={()=>{
              setIsErrorModal(false);
              window.location.reload();
            }}
            keyboard
            backdrop
          >
            <div className="text-center">
              {localization.oppsWrong}
            </div>
      </ErrModalPop>
      <TableSection
        data={listData}
        isId={true}
        headers={headerState}
        pageCount={pageCount}
        srNo={valetincentivelisting?.from}
        onPageChange={onPageChange}
        detailList={valetincentivelisting && valetincentivelisting.resultSets}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}

      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        valetIncentiveFilter
      />
    </Layout>
  );
};

export default ValetUserList;
